import { SupportIcon } from 'assets/svg/sidebarIcons';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const support = {
  id: 'support',
  title: '',
  type: 'group',
  children: [
    {
      id: 'support-management',
      title: 'Support',
      type: 'item',
      url: '/support',
      icon: SupportIcon,
      allowedRoles: ['admin', 'superAdmin', 'supportAgent'],
      breadcrumbs: false
    }
  ]
};

export default support;
